import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss']
})
export class ModalConfirmComponent implements OnInit {
  textButton: any;
  textTitle: any;
  txtContent: any;
  type: any;
  icon: any;
  elementId: any;
  comments = false;
  commentsTxt: string;

  constructor(public dialogRef: MatDialogRef<ModalConfirmComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    // console.log(this.data);
    this.textButton = this.data.button;
    this.textTitle = this.data.title;
    this.txtContent = this.data.content;
    this.type = this.data.type;
    this.icon = this.data.icon;
    this.elementId = this.data.id;
    this.comments = this.data.comments;

  }

  ngOnInit() {
  }


  onCloseConfirm() {
    this.dialogRef.close({resp: true, comments: this.commentsTxt});
  }
  onCloseCancel() {
    this.dialogRef.close();
  }

}
